import React, { useState, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../assets";
import logobhavishya from "../../assets/logo_bhavishya_4.png";

const SmallScreenNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = {
    "About Us": "/about",
    "Program": "/programs",
    "Success Stories": "/successstory",
    "Our Presence": "/ourcenters",
    "Products": "/products",
    "Media": "/media",
    "Get in touch": "/contact",
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Close menu on route change
  useEffect(() => {
    return () => {
      setIsOpen(false);
    };
  }, []);

  const handleJoinUsClick = () => {
    closeMenu();
    
    if (location.pathname === "/contact") {
      // If already on contact page, scroll to section
      setTimeout(() => {
        const element = document.getElementById("join-us-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // If not on contact page, navigate to contact page
      window.location.href = "/contact#join-us-section";
    }
  };

  return (
    <>
      {/* Navbar Header - Hamburger */}
      <nav className="xl:hidden bg-[#EE645A] sticky top-0 z-50 w-full shadow-lg">
        <div className="px-3 sm:px-4 py-2 sm:py-2.5 flex items-center justify-between gap-2">
          {/* Logo and Text - Responsive sizing */}
          <Link 
            to="/" 
            className="flex items-center shrink-0 group hover:opacity-90 transition-opacity"
            onClick={closeMenu}
          >
            <img 
              src={Logo} 
              alt="Bhavishya Logo" 
              className="w-14 sm:w-14 h-14 sm:h-14 object-contain" 
            />
            <img 
              src={logobhavishya} 
              alt="Bhavishya Text" 
              className="w-32 sm:w-32 h-auto object-contain" 
            />
          </Link>
          
          {/* Hamburger Button */}
          <button
            onClick={toggleMenu}
            className="p-2 rounded-md hover:bg-white/20 transition-colors flex-shrink-0 ml-auto"
            aria-label="Toggle menu"
            aria-expanded={isOpen}
          >
            {isOpen ? (
              <IoClose className="w-6 h-6 text-white" />
            ) : (
              <GiHamburgerMenu className="w-6 h-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isOpen && (
          <div className="bg-[#EE645A] border-t-2 border-white/30 animate-in fade-in slide-in-from-top-2 duration-200">
            <div className="px-4 py-4 sm:px-6 sm:py-5 max-h-[calc(100vh-70px)] overflow-y-auto">
              {/* Navigation Links */}
              <div className="flex flex-col space-y-2 sm:space-y-3 mb-5">
                {Object.keys(navLinks).map((item) => (
                  <Link
                    key={item}
                    to={navLinks[item]}
                    onClick={closeMenu}
                    className="font-semibold text-white text-base sm:text-lg transition-all duration-300 hover:text-gray-100 py-2.5 px-3 rounded-md hover:bg-white/20 block"
                  >
                    {item}
                  </Link>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col gap-3 border-t border-white/30 pt-4">
                <Link
                  to="/donate"
                  onClick={closeMenu}
                  className="bg-black text-white px-4 py-2.5 sm:py-3 rounded-lg font-bold text-sm sm:text-base transition-all duration-300 hover:bg-white hover:text-black text-center w-full transform hover:scale-105 hover:shadow-lg"
                >
                  Donate Now
                </Link>
                <button
                  onClick={handleJoinUsClick}
                  className="bg-black text-white px-4 py-2.5 sm:py-3 rounded-lg font-bold text-sm sm:text-base transition-all duration-300 hover:bg-white hover:text-black text-center w-full transform hover:scale-105 hover:shadow-lg cursor-pointer"
                >
                  Join Us
                </button>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Backdrop when menu is open */}
      {isOpen && (
        <div 
          className="xl:hidden fixed inset-0 bg-black/40 z-40 top-[54px] sm:top-[60px] animate-in fade-in duration-200"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default SmallScreenNavbar;